//@ts-nocheck

import React, { useCallback } from "react";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar";
export type ToastProps = {
  message: string;
  open?: boolean;
  onClose: Function;
  type: "success" | "error" | "warning";
};
export type showToastProps = {
  message: string;
  type: string;
};
export const Toast = (props: ToastProps) => {
  const { open, onClose, message, type } = props;
  let color;
  switch (type) {
    case "success":
      color = "#54A4A6";
      break;
    case "error":
      color = "#d32f2f";
      break;
    case "warning":
      color = "#FDC784";
      break;  
    default:
      color = "#313131";
      break;
  }
  const handleClose = (event: any, reason: string) => {
    onClose(event, reason);
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <SnackbarContent
        style={{
          backgroundColor: color,
          borderRadius: "12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "10px 32px",
        }}
        message={
          <span
            id="toast"
            style={{
              color: "#fff",
              fontFamily: "Lato",
              fontSize: "1rem",
              fontWeight: "bold",
              textTransform: "capitalize",
              letterSpacing: "1px",
            }}
          >
            {message}
          </span>
        }
      />
    </Snackbar>
  );
};

export const ToastContext = React.createContext({});

export const ToastProvider: React.FunctionComponent = ({ children }) => {
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
  const [dialogConfig, setDialogConfig] = React.useState<any>({});

  const openToast = ({ message, type }: showToastProps) => {
    setDialogOpen(true);
    setDialogConfig({ message, type });
  };

  const hideToast = React.useCallback((event) => {
    setDialogOpen(false);
    setDialogConfig({});
  }, []);

  return (
    <ToastContext.Provider value={{ openToast }}>
      <Toast
        open={dialogOpen}
        type={dialogConfig.type}
        message={dialogConfig.message}
        onClose={hideToast}
      />
      {children}
    </ToastContext.Provider>
  );
};
